
import React, { Fragment } from 'react'

import routes from 'routes/public/contracts'


const ContractsContainer = () =>
  <Fragment>
    { routes }
  </Fragment>


export default ContractsContainer
